export const CATALOG_SERVICE_META_ATTRIBUTES = ['attr_tokens', 'catalog_type', 'deleted', 'enabled_units', 'disabled_units', 'enabled_units_all', 'id', 'unit_overrides', 'unknown_attrs', 'version', 'item_option_ids', 'item_option_ids_from_option_values', 'item_option_value_ids', 'custom_attributes', 'resources'];

// To allow client-specified relationships with only server-generated ids:
// The server replaces each temporary-token-prefixed object id with a new id.
// Each attribute of other objects referencing the same temporary token id will
// also be changed to match the new server-generated id.
// Temporary token id substitution only applies within an individual request.
export const CATALOG_SERVICE_TEMP_TOKEN_PREFIX = '#';
const attrType = {
  STRING: 1,
  INT: 2,
  BOOLEAN: 3,
  TOKEN: 4,
  ENUM: 5,
  TEXT: 6,
  PERCENT: 7,
  JSON: 8,
  ITEM_OPTION: 9,
  ITEM_OPTION_VAL: 10,
  STRING_AND_INT: 11,
  TOKEN_AND_INT: 12
};
export { attrType as CATALOG_ATTR_TYPES };
export const CATALOG_SERVICE_ITEM_OPTION_ATTRIBUTE_TOKENS = ['SQ_IO_0', 'SQ_IO_1', 'SQ_IO_2', 'SQ_IO_3', 'SQ_IO_4', 'SQ_IO_5'];
export const CATALOG_SERVICE_ITEM_OPTION_VAL_ATTRIBUTE_TOKENS = ['SQ_IOV_0', 'SQ_IOV_1', 'SQ_IOV_2', 'SQ_IOV_3', 'SQ_IOV_4', 'SQ_IOV_5'];
export const CATALOG_SERVICE_RESOURCE_TOKEN = 'SQ_APPT_RES';

// For composite attributes such as "price" use names of
// the form "compositeName.subAttributeName" below
// E.g. "price.cents" and "price.currency_code"
export const CATALOG_SERVICE_ATTRIBUTE_DEFINITIONS = {
  abbreviation: {
    token: 'SQ_IA',
    type: attrType.STRING
  },
  action_type: {
    token: 'SQ_TRAT',
    type: attrType.ENUM
  },
  active: {
    token: 'SQ_PA',
    type: attrType.BOOLEAN
  },
  additional_categories: {
    token: 'SQ_ADDITIONAL_CATEGORY',
    type: attrType.STRING_AND_INT,
    repeated: {
      ITEM: true
    }
  },
  age_restriction_id: {
    token: 'SQ_AGE_RESTRICTION_TOKEN',
    type: attrType.TOKEN
  },
  allow_quantities: {
    token: 'SQ_ALLOW_QUANTITIES',
    type: attrType.BOOLEAN
  },
  allow_quantities_override: {
    token: 'SQ_ALLOW_QUANTITIES_OVERRIDE',
    type: attrType.ENUM
  },
  almanac_event_id: {
    token: 'SQ_ALMANAC_EVENT_ID',
    type: attrType.STRING
  },
  category_type: {
    token: 'SQ_CATEGORY_TYPE',
    type: attrType.ENUM
  },
  adjusted_product_set_id: {
    token: 'SQ_PRICE_APPLY_PRODUCT',
    type: attrType.TOKEN
  },
  adjustment_type: {
    token: 'SQ_ADJ',
    type: attrType.INT
  },
  application_method: {
    token: 'SQ_DAM',
    type: attrType.ENUM
  },
  applies_to_custom_amounts: {
    token: 'SQ_FACA',
    type: attrType.BOOLEAN
  },
  appointment_employees: {
    token: 'SQ_APPT_ET',
    type: attrType.STRING,
    repeated: {
      ITEM_VARIATION: true
    }
  },
  intermissions: {
    token: 'SQ_APPT_INTERMISSION',
    type: attrType.JSON
  },
  auto_enable_type: {
    token: 'SQ_AET',
    type: attrType.ENUM
  },
  available_electronically: {
    token: 'SQ_OS_3',
    type: attrType.BOOLEAN
  },
  available_online: {
    token: 'SQ_OS_1',
    type: attrType.BOOLEAN
  },
  available_for_pickup: {
    token: 'SQ_OS_2',
    type: attrType.BOOLEAN
  },
  buyer_facing_name: {
    token: 'SQ_OS_4',
    type: attrType.STRING
  },
  calculation_phase: {
    token: 'SQ_CP',
    type: attrType.INT
  },
  channels: {
    token: 'SQ_CHANNELS',
    type: attrType.STRING,
    repeated: {
      ITEM: true,
      ITEM_VARIATION: true
    }
  },
  color: {
    token: 'SQ_REG_1',
    type: attrType.STRING
  },
  column: {
    token: 'SQ_REG_IPMC',
    type: attrType.INT
  },
  combo_slot_ids: {
    token: 'SQ_COMBO_SLOT_TOKEN',
    type: attrType.TOKEN_AND_INT,
    repeated: {
      ITEM: true
    }
  },
  composition_id: {
    token: 'SQ_COMPOSITION_ID',
    type: attrType.TOKEN
  },
  composition_type: {
    token: 'SQ_COMPOSITION_TYPE',
    type: attrType.INT
  },
  credits_validity_duration: {
    token: 'SQ_CRED_VAL_DUR',
    type: attrType.STRING
  },
  customer_group_ids_any: {
    token: 'SQ_PRICE_CUSTOMER_GROUPS_ANY',
    type: attrType.TOKEN,
    repeated: {
      PRICING_RULE: true
    }
  },
  date_time_start: {
    token: 'SQ_STARTS_AT',
    type: attrType.STRING
  },
  date_time_end: {
    token: 'SQ_ENDS_AT',
    type: attrType.STRING
  },
  default_item_variation_id: {
    token: 'SQ_DEFAULT_ITEM_VARIATION_TOKEN',
    type: attrType.TOKEN
  },
  dining_option_predicate_type: {
    token: 'SQ_DOPT',
    type: attrType.ENUM
  },
  dining_option_id: {
    token: 'SQ_DO',
    type: attrType.TOKEN,
    repeated: {
      TAX_RULE: true
    }
  },
  discount_id: {
    token: 'SQ_COGS_DID',
    type: attrType.TOKEN
  },
  delivery_fulfillment_preferences_id: {
    token: 'SQ_FPDI',
    type: attrType.STRING
  },
  description: {
    token: 'SQ_6',
    type: attrType.STRING
  },
  dine_in_fulfillment_preferences_id: {
    token: 'SQ_FPDII',
    type: attrType.STRING
  },
  disabled_pricing_sources: {
    token: 'SQ_PRICE_DISABLED_PRICING_SOURCES',
    type: attrType.ENUM,
    repeated: {
      PRICING_RULE: true
    }
  },
  discount_target_scope: {
    token: 'SQ_PRICE_DISCOUNT_TARGET_SCOPE',
    type: attrType.ENUM
  },
  discount_type: {
    token: 'SQ_DT',
    type: attrType.ENUM
  },
  duration: {
    token: 'SQ_DURATION',
    type: attrType.STRING
  },
  ecom_allow_order_item_quantities: {
    token: 'SQ_ECOM_ALLOW_ORDER_ITEM_QUANTITIES',
    type: attrType.BOOLEAN
  },
  ecom_available: {
    token: 'SQ_ECOM_AVAIL',
    type: attrType.BOOLEAN
  },
  ecom_buy_button_text: {
    token: 'SQ_ECOM_BUY_BUTTON_TEXT',
    type: attrType.STRING
  },
  ecom_order_item_max_quantity: {
    token: 'SQ_ECOM_ORDER_ITEM_MAX_QUANTITY',
    type: attrType.INT
  },
  ecom_seo_page_description: {
    token: 'SQ_ECOM_SEO_PAGE_DESCRIPTION',
    type: attrType.STRING
  },
  ecom_seo_page_title: {
    token: 'SQ_ECOM_SEO_PAGE_TITLE',
    type: attrType.STRING
  },
  ecom_seo_permalink: {
    token: 'SQ_ECOM_SEO_PERMALINK',
    type: attrType.STRING
  },
  ecom_uri: {
    token: 'SQ_ECOM_URI',
    type: attrType.STRING
  },
  ecom_visibility: {
    token: 'SQ_ECOM_VISIBILITY',
    type: attrType.ENUM
  },
  enabled: {
    token: 'SQ_16',
    type: attrType.BOOLEAN
  },
  enabled_pricing_sources: {
    token: 'SQ_PRICE_ENABLED_PRICING_SOURCES',
    type: attrType.INT,
    repeated: {
      PRICING_RULE: true
    }
  },
  ends_at: {
    token: 'SQ_PEA',
    type: attrType.INT
  },
  exact_quantity: {
    token: 'SQ_EXACT_QUANTITY',
    type: attrType.INT
  },
  exclude_product_set_id: {
    token: 'SQ_PRICE_EXCLUDE_PRODUCT',
    type: attrType.TOKEN
  },
  exclude_strategy: {
    token: 'SQ_PRICE_EXCLUDE_STRATEGY',
    type: attrType.ENUM
  },
  fee_id: {
    token: 'SQ_COGS_FID',
    type: attrType.TOKEN
  },
  fee_type_id: {
    token: 'SQ_COGS_FTI',
    type: attrType.STRING
  },
  fee_type_name: {
    token: 'SQ_COGS_FTN',
    type: attrType.STRING
  },
  floor_plan_id: {
    token: 'SQ_COGS_FP_ID',
    type: attrType.TOKEN
  },
  floor_plan_tile_shape: {
    token: 'SQ_COGS_FPT_SHAPE',
    type: attrType.ENUM
  },
  sort_name: {
    token: 'SQ_SORT_NAME',
    type: attrType.STRING
  },
  gtin: {
    token: 'SQ_13',
    type: attrType.STRING
  },
  has_suggested_purchase_amount: {
    token: 'SQ_HAS_PURCHASE_SUGGESTED_AMOUNT',
    type: attrType.BOOLEAN
  },
  height: {
    token: 'SQ_HEIGHT',
    type: attrType.INT
  },
  hidden_from_customer: {
    token: 'SQ_REST_5',
    type: attrType.BOOLEAN
  },
  hidden_from_customer_override: {
    token: 'SQ_IIMLM_HIDDEN_FROM_CUSTOMER_OVERRIDE',
    type: attrType.ENUM
  },
  hidden_online: {
    token: 'SQ_HIDDEN_ONLINE',
    type: attrType.BOOLEAN
  },
  html_description: {
    token: 'SQ_HTML_DESCRIPTION',
    type: attrType.TEXT
  },
  image_id: {
    token: 'SQ_COGS_IMID',
    type: attrType.STRING
  },
  include_custom_amounts: {
    token: 'SQ_ATCA',
    type: attrType.BOOLEAN
  },
  is_conversational: {
    token: 'SQ_REST_6',
    type: attrType.BOOLEAN
  },
  is_conversational_override: {
    token: 'SQ_IS_CONVERSATIONAL_OVERRIDE',
    type: attrType.ENUM
  },
  is_default: {
    token: 'SQ_DEFAULT',
    type: attrType.BOOLEAN
  },
  item_config_filter: {
    token: 'SQ_ICOF',
    type: attrType.ENUM
  },
  item_id: {
    token: 'SQ_COGS_IID',
    type: attrType.TOKEN,
    repeated: {
      TAX_RULE: true
    }
  },
  item_modifier_option_overrides: {
    token: 'SQ_REG_IIMLMIMOO',
    type: attrType.JSON
  },
  minimum_buyer_age: {
    token: 'SQ_MINIMUM_BUYER_AGE',
    type: attrType.INT
  },
  'minimum_order_subtotal_money.amount': {
    token: 'SQ_PRICE_MOS',
    type: attrType.INT
  },
  'minimum_order_subtotal_money.currency_code': {
    token: 'SQ_2',
    type: attrType.STRING
  },
  image_memberships: {
    token: 'SQ_COGS_IMID',
    type: attrType.STRING_AND_INT,
    repeated: {
      ITEM: true,
      ITEM_VARIATION: true,
      ITEM_MODIFIER_OPTION: true
    }
  },
  item_variation_id: {
    token: 'SQ_COGS_IVID',
    type: attrType.TOKEN
  },
  inclusion_type: {
    token: 'SQ_FIT',
    type: attrType.INT
  },
  inventory_alert_threshold: {
    token: 'SQ_IVIATH',
    type: attrType.INT
  },
  inventory_alert_type: {
    token: 'SQ_IVIATY',
    type: attrType.INT
  },
  is_archived: {
    token: 'SQ_IS_ARCHIVED',
    type: attrType.BOOLEAN
  },
  is_alcoholic: {
    token: 'SQ_IS_ALCOHOLIC',
    type: attrType.BOOLEAN
  },
  item_option_zero: {
    token: CATALOG_SERVICE_ITEM_OPTION_ATTRIBUTE_TOKENS[0],
    type: attrType.ITEM_OPTION
  },
  item_option_one: {
    token: CATALOG_SERVICE_ITEM_OPTION_ATTRIBUTE_TOKENS[1],
    type: attrType.ITEM_OPTION
  },
  item_option_two: {
    token: CATALOG_SERVICE_ITEM_OPTION_ATTRIBUTE_TOKENS[2],
    type: attrType.ITEM_OPTION
  },
  item_option_three: {
    token: CATALOG_SERVICE_ITEM_OPTION_ATTRIBUTE_TOKENS[3],
    type: attrType.ITEM_OPTION
  },
  item_option_four: {
    token: CATALOG_SERVICE_ITEM_OPTION_ATTRIBUTE_TOKENS[4],
    type: attrType.ITEM_OPTION
  },
  item_option_five: {
    token: CATALOG_SERVICE_ITEM_OPTION_ATTRIBUTE_TOKENS[5],
    type: attrType.ITEM_OPTION
  },
  item_option_value_zero: {
    token: CATALOG_SERVICE_ITEM_OPTION_VAL_ATTRIBUTE_TOKENS[0],
    type: attrType.ITEM_OPTION_VAL
  },
  item_option_value_one: {
    token: CATALOG_SERVICE_ITEM_OPTION_VAL_ATTRIBUTE_TOKENS[1],
    type: attrType.ITEM_OPTION_VAL
  },
  item_option_value_two: {
    token: CATALOG_SERVICE_ITEM_OPTION_VAL_ATTRIBUTE_TOKENS[2],
    type: attrType.ITEM_OPTION_VAL
  },
  item_option_value_three: {
    token: CATALOG_SERVICE_ITEM_OPTION_VAL_ATTRIBUTE_TOKENS[3],
    type: attrType.ITEM_OPTION_VAL
  },
  item_option_value_four: {
    token: CATALOG_SERVICE_ITEM_OPTION_VAL_ATTRIBUTE_TOKENS[4],
    type: attrType.ITEM_OPTION_VAL
  },
  item_option_value_five: {
    token: CATALOG_SERVICE_ITEM_OPTION_VAL_ATTRIBUTE_TOKENS[5],
    type: attrType.ITEM_OPTION_VAL
  },
  weight_amount: {
    token: 'SQ_ITEM_WEIGHT_AMOUNT',
    type: attrType.INT
  },
  weight_unit: {
    token: 'SQ_ITEM_WEIGHT_TYPE',
    type: attrType.ENUM
  },
  limited_use: {
    token: 'SQ_PLU',
    type: attrType.BOOLEAN
  },
  match_all_products: {
    token: 'SQ_MATCH_ALL',
    type: attrType.BOOLEAN
  },
  match_custom_amounts: {
    token: 'SQ_MCA',
    type: attrType.BOOLEAN
  },
  max_applications_per_attachment: {
    token: 'SQ_PRICE_MAX_APPLICATIONS_PER_ATTACHMENT',
    type: attrType.INT
  },
  max_quantity: {
    token: 'SQ_MAX_QUANTITY',
    type: attrType.INT
  },
  max_selected_modifiers: {
    token: 'SQ_REST_3',
    type: attrType.INT
  },
  maximum_amount: {
    token: 'SQ_DMA',
    type: attrType.INT
  },
  measurement_unit_id: {
    token: 'SQ_MU_ID',
    type: attrType.TOKEN
  },
  min_selected_modifiers: {
    token: 'SQ_REST_2',
    type: attrType.INT
  },
  modifier_list_id: {
    token: 'SQ_COGS_MLID',
    type: attrType.TOKEN
  },
  menu_category_id: {
    token: 'SQ_COGS_MCID',
    type: attrType.TOKEN
  },
  menu_group_membership_id: {
    token: 'SQ_COGS_MGM_ID',
    type: attrType.TOKEN
  },
  menu_group_membership_parent_menu_group_id: {
    token: 'SQ_COGS_MGM_PMG_ID',
    type: attrType.TOKEN
  },
  menu_group_membership_member_item_ordinal: {
    token: 'SQ_MGM_MIO',
    type: attrType.INT
  },
  menu_group_membership_member_menu_group_ordinal: {
    token: 'SQ_MGM_MMGO',
    type: attrType.INT
  },
  minimum_seat_count: {
    token: 'SQ_MIN_SEAT',
    type: attrType.INT
  },
  min_quantity: {
    token: 'SQ_MIN_QUANTITY',
    type: attrType.INT
  },
  max_length: {
    token: 'SQ_MOD_TEXT_MAX_LENGTH',
    type: attrType.INT
  },
  modifier_type: {
    token: 'SQ_MOD_TYPE',
    type: attrType.ENUM
  },
  modify_tax_basis: {
    token: 'SQ_DTAX',
    type: attrType.ENUM
  },
  multi_unit_mode: {
    token: 'SQ_MULTI_UNIT_MODE',
    type: attrType.BOOLEAN
  },
  name: {
    token: 'SQ_3',
    type: attrType.STRING
  },
  internal_name: {
    token: 'SQ_MOD_I_NAME',
    type: attrType.STRING
  },
  kitchen_name: {
    token: 'SQ_KITCHEN_NAME',
    type: attrType.STRING
  },
  'no_show_fee.cents': {
    token: 'SQ_APPT_NSF',
    type: attrType.INT
  },
  'no_show_fee.currency_code': {
    token: 'SQ_APPT_NSFCC',
    type: attrType.STRING
  },
  no_show_fee_percentage: {
    token: 'SQ_APPT_NSF_PCT',
    type: attrType.INT
  },
  num_selections: {
    token: 'SQ_NUM_SELECTIONS',
    type: attrType.INT
  },
  num_times_allowed: {
    token: 'SQ_PNTA',
    type: attrType.INT
  },
  num_times_used: {
    token: 'SQ_PNTU',
    type: attrType.INT
  },
  ordinal: {
    token: 'SQ_REG_2',
    type: attrType.INT
  },
  on_by_default: {
    token: 'SQ_REG_IMOOBD',
    type: attrType.BOOLEAN
  },
  text_required: {
    token: 'SQ_MOD_TEXT_REQUIRED',
    type: attrType.BOOLEAN
  },
  online_store_item_data: {
    token: 'SQ_OS_ID',
    type: attrType.JSON
  },
  online_booking_available: {
    token: 'SQ_APPT_AV',
    type: attrType.BOOLEAN
  },
  open_graph_link_title: {
    token: 'SQ_OG_LINK_TITLE',
    type: attrType.STRING
  },
  open_graph_link_description: {
    token: 'SQ_OG_LINK_DESCRIPTION',
    type: attrType.STRING
  },
  page_id: {
    token: 'SQ_COGS_PID',
    type: attrType.TOKEN
  },
  page_index: {
    token: 'SQ_REG_PPI',
    type: attrType.INT
  },
  page_layout: {
    token: 'SQ_REG_CPL',
    type: attrType.INT
  },
  percentage: {
    token: 'SQ_5',
    type: attrType.PERCENT
  },
  pickup_fulfillment_preferences_id: {
    token: 'SQ_FPPI',
    type: attrType.STRING
  },
  pin_required: {
    token: 'SQ_DPR',
    type: attrType.BOOLEAN
  },
  placeholder_id: {
    token: 'SQ_COGS_PLID',
    type: attrType.TOKEN
  },
  placeholder_type: {
    token: 'SQ_REG_PPT',
    type: attrType.INT
  },
  pos_display_name: {
    token: 'SQ_POS_DISPLAY_NAME',
    type: attrType.STRING
  },
  precision: {
    token: 'SQ_MU_P',
    type: attrType.INT
  },
  // TODO (cclegg): We should be able to change `cents` to `amount` and use the Money transform everywhere instead of
  // LegacyMoney. This will likely break various tests though.
  'price.cents': {
    token: 'SQ_1',
    type: attrType.INT
  },
  'price.currency_code': {
    token: 'SQ_2',
    type: attrType.STRING
  },
  max_item_price: {
    token: 'SQ_MAXIP',
    type: attrType.INT
  },
  max_total_amount: {
    token: 'SQ_MTA',
    type: attrType.INT
  },
  photo_studio_order_id: {
    token: 'SQ_PHOTO_STUDIO_ODER_ID',
    type: attrType.STRING
  },
  price_application: {
    token: 'SQ_PRICE_APPLICATION',
    type: attrType.ENUM
  },
  price_description: {
    token: 'SQ_PD',
    type: attrType.STRING
  },
  pricing_application_mode: {
    token: 'SQ_PRICE_APPLICATION_MODE',
    type: attrType.ENUM
  },
  pricing_rule_id: {
    token: 'SQ_PRICING_TOKEN',
    type: attrType.TOKEN
  },
  pricing_type: {
    token: 'SQ_15',
    type: attrType.ENUM
  },
  product_name: {
    token: 'SQ_PN',
    type: attrType.ENUM
  },
  product_set_all_ids: {
    token: 'SQ_PRODUCTS_ALL_PRODUCT_SET',
    type: attrType.TOKEN,
    repeated: {
      PRODUCT_SET: true
    }
  },
  product_set_any_ids: {
    token: 'SQ_PRODUCTS_ANY_PRODUCT_SET',
    type: attrType.TOKEN,
    repeated: {
      PRODUCT_SET: true
    }
  },
  product_set_id: {
    token: 'SQ_COGS_PSID',
    type: attrType.TOKEN
  },
  product_line_item_types: {
    token: 'SQ_PRODUCT_LINE_ITEM_TYPES',
    type: attrType.ENUM,
    repeated: {
      PRODUCT_SET: true
    }
  },
  quantity: {
    token: 'SQ_QUANTITY',
    type: attrType.INT
  },
  quantity_denominator: {
    token: 'SQ_QUANTITY_DENOMINATOR',
    type: attrType.INT
  },
  required_category_ids: {
    token: 'SQ_PRODUCTS_ALL_CATEGORY',
    type: attrType.TOKEN,
    repeated: {
      PRODUCT_SET: true
    }
  },
  required_item_ids: {
    token: 'SQ_PRODUCTS_ALL_ITEM',
    type: attrType.TOKEN,
    repeated: {
      PRODUCT_SET: true
    }
  },
  required_surcharge_ids: {
    token: 'SQ_PRODUCTS_ALL_SURCHARGE',
    type: attrType.TOKEN,
    repeated: {
      PRODUCT_SET: true
    }
  },
  required_item_variation_ids: {
    token: 'SQ_PRODUCTS_ALL_ITEM_VARIATION',
    type: attrType.TOKEN,
    repeated: {
      PRODUCT_SET: true
    }
  },
  'service_cost_flat.amount': {
    token: 'SQ_SERVICE_COST_FLAT',
    type: attrType.INT
  },
  'service_cost_flat.currency_code': {
    token: 'SQ_SERVICE_COST_CURRENCY',
    type: attrType.STRING
  },
  service_cost_percentage: {
    token: 'SQ_SERVICE_COST_PERCENT',
    type: attrType.INT
  },
  requires_subscription_to_sell: {
    token: 'SQ_REQUIRES_SUBSCRIPTION_TO_SELL',
    type: attrType.BOOLEAN
  },
  allowed_category_ids: {
    token: 'SQ_PRODUCTS_ANY_CATEGORY',
    type: attrType.TOKEN,
    repeated: {
      PRODUCT_SET: true
    }
  },
  allowed_item_ids: {
    token: 'SQ_PRODUCTS_ANY_ITEM',
    type: attrType.TOKEN,
    repeated: {
      PRODUCT_SET: true
    }
  },
  allowed_item_variation_ids: {
    token: 'SQ_PRODUCTS_ANY_ITEM_VARIATION',
    type: attrType.TOKEN,
    repeated: {
      PRODUCT_SET: true
    }
  },
  allowed_surcharge_ids: {
    token: 'SQ_PRODUCTS_ANY_SURCHARGE',
    type: attrType.TOKEN,
    repeated: {
      PRODUCT_SET: true
    }
  },
  shipping_fulfillment_preferences_id: {
    token: 'SQ_FPSI',
    type: attrType.STRING
  },
  subscription_phase_type: {
    token: 'SQ_SUBSCRIPTION_PHASE_TYPE',
    type: attrType.ENUM
  },
  subscription_cadence: {
    token: 'SQ_SUBSCRIPTION_CADENCE',
    type: attrType.ENUM
  },
  subscription_periods: {
    token: 'SQ_SUBSCRIPTION_PERIODS',
    type: attrType.INT
  },
  subscription_plan_id: {
    token: 'SQ_SUBSCRIPTION_PLAN_TOKEN',
    type: attrType.TOKEN
  },
  surcharge_calculation_type: {
    token: 'SQ_SCT',
    type: attrType.ENUM
  },
  ecom_apply_to_fulfillment_types: {
    token: 'SQ_SEFT',
    type: attrType.STRING,
    repeated: {
      SURCHARGE: true
    }
  },
  payment_type: {
    token: 'SQ_PRICE_PAYMENT_TYPES',
    type: attrType.ENUM
  },
  promo_code: {
    token: 'SQ_PPC',
    type: attrType.STRING
  },
  recipe_id: {
    token: 'SQ_RECIPE_TOKEN',
    type: attrType.TOKEN
  },
  recurrence_rule: {
    token: 'SQ_RECURRENCE_RULE',
    type: attrType.STRING
  },
  rotation_angle: {
    token: 'SQ_COGS_FPT_RA',
    type: attrType.INT
  },
  row: {
    token: 'SQ_REG_IPMR',
    type: attrType.INT
  },
  sale_price: {
    token: 'SQ_SALE_PRICE_TOKEN',
    type: attrType.TOKEN
  },
  sale_price_type: {
    token: 'SQ_SPT',
    type: attrType.ENUM
  },
  selection_type: {
    token: 'SQ_REG_IMLST',
    type: attrType.ENUM
  },
  sellable: {
    token: 'SQ_SELLABLE',
    type: attrType.BOOLEAN
  },
  service_duration: {
    token: 'SQ_APPT_SD',
    type: attrType.INT
  },
  show_tile_label: {
    token: 'SQ_POS_SHOW_TILE_LABEL',
    type: attrType.BOOLEAN
  },
  skips_modifier_screen: {
    token: 'SQ_REST_4',
    type: attrType.BOOLEAN
  },
  sku: {
    token: 'SQ_14',
    type: attrType.STRING
  },
  sold_out: {
    token: 'SQ_SOLD_OUT',
    type: attrType.BOOLEAN
  },
  sold_out_valid_until: {
    token: 'SQ_SOLD_OUT_VALID_UNTIL',
    type: attrType.STRING
  },
  starts_at: {
    token: 'SQ_PSA',
    type: attrType.INT
  },
  stockable: {
    token: 'SQ_STOCKABLE',
    type: attrType.BOOLEAN
  },
  straight_fire: {
    token: 'SQ_REST_SF',
    type: attrType.INT
  },
  surcharge_id: {
    token: 'SQ_COGS_SID',
    type: attrType.TOKEN
  },
  surcharge_type: {
    token: 'SQ_ST',
    type: attrType.ENUM
  },
  surcharge_target_scope: {
    token: 'SQ_PRICE_SURCHARGE_TARGET_SCOPE',
    type: attrType.ENUM
  },
  tag_id: {
    token: 'SQ_COGS_TAG_ID',
    type: attrType.TOKEN,
    repeated: {
      TAG: true,
      ITEM: true
    }
  },
  tag_type: {
    token: 'SQ_TT',
    type: attrType.ENUM
  },
  target_product_set_id: {
    token: 'SQ_PRICE_MATCH_PRODUCT',
    type: attrType.TOKEN
  },
  taxable: {
    token: 'SQ_ITAX',
    type: attrType.BOOLEAN
  },
  taxable_non_item: {
    token: 'SQ_TAX',
    type: attrType.BOOLEAN
  },
  tax_config_filter: {
    token: 'SQ_TCOF',
    type: attrType.ENUM
  },
  ticket_group_id: {
    token: 'SQ_COGS_TGID',
    type: attrType.TOKEN
  },
  ticket_group_label: {
    token: 'SQ_COGS_TG_LB',
    type: attrType.STRING
  },
  ticket_group_naming_method: {
    token: 'SQ_REG_TGNM',
    type: attrType.INT
  },
  ticket_template_id: {
    token: 'SQ_COGS_TT_ID',
    type: attrType.TOKEN
  },
  time_period_ids: {
    token: 'SQ_COGS_TIME_PERIOD_ID',
    type: attrType.TOKEN,
    repeated: {
      PRICING_RULE: true
    }
  },
  track_inventory: {
    token: 'SQ_IVTI',
    type: attrType.BOOLEAN
  },
  transition_time: {
    token: 'SQ_APPT_TT',
    type: attrType.INT
  },
  treatment_type: {
    token: 'SQ_STT',
    type: attrType.ENUM
  },
  type: {
    token: 'SQ_10',
    type: attrType.ENUM
  },
  unit_enabled: {
    token: 'SQ_COGS_E',
    type: attrType.BOOLEAN
  },
  url: {
    token: 'SQ_URL',
    type: attrType.STRING
  },
  use_color_background: {
    token: 'SQ_POS_USE_COLOR_BACKGROUND',
    type: attrType.BOOLEAN
  },
  vendor_id: {
    token: 'SQ_VENDOR',
    type: attrType.TOKEN
  },
  visibility: {
    token: 'SQ_VIS',
    type: attrType.ENUM
  },
  width: {
    token: 'SQ_WIDTH',
    type: attrType.INT
  },
  x: {
    token: 'SQ_COGS_POSITION_X',
    type: attrType.INT
  },
  y: {
    token: 'SQ_COGS_POSITION_Y',
    type: attrType.INT
  },
  z_order: {
    token: 'SQ_Z_ORDER',
    type: attrType.INT
  },
  // from inventory2 through items-bulk
  fractional_inventory_in_stock_count: {
    token: 'FractionalInventoryInStockCount',
    type: attrType.STRING
  },
  fractional_inventory_committed_count: {
    token: 'FractionalInventoryCommittedCount',
    type: attrType.STRING
  },
  fractional_inventory_available_count: {
    token: 'FractionalInventoryAvailableCount',
    type: attrType.STRING
  },
  inventory_in_stock_count: {
    token: 'InventoryInStockCount',
    type: attrType.INT
  },
  inventory_stock_received_count: {
    token: 'InventoryStockReceivedCount',
    type: attrType.STRING
  },
  inventory_adjustment_unit_cost: {
    token: 'InventoryAdjustmentUnitCost',
    type: attrType.INT
  },
  inventory_adjustment_currency_code: {
    token: 'InventoryAdjustmentCurrencyCode',
    type: attrType.STRING
  },
  inventory_availability_rule: {
    token: 'InventoryAvailabilityRule',
    type: attrType.INT
  },
  inventory_availability_rule_expires_at: {
    token: 'InventoryAvailabilityRuleExpiresAt',
    type: attrType.STRING
  },
  stackable: {
    token: 'SQ_PRICE_STACKABLE',
    type: attrType.ENUM
  },
  ecom_apply_to_fulfillment_type_service_charges: {
    token: 'SQ_PRICE_EFT_SERVICE_CHARGES',
    type: attrType.STRING,
    repeated: {
      PRICING_RULE: true
    }
  },
  // type specific attributes for items of type FOOD_AND_BEV
  food_and_bev_calorie_count: {
    token: 'SQ_FOOD_AND_BEV_CALORIE_COUNT',
    type: attrType.INT
  },
  food_and_bev_dietary_preferences: {
    token: 'SQ_FOOD_AND_BEV_DIETARY_PREFERENCES',
    type: attrType.STRING_AND_INT,
    repeated: {
      ITEM: true
    }
  },
  food_and_bev_ingredients: {
    token: 'SQ_FOOD_AND_BEV_INGREDIENTS',
    type: attrType.STRING_AND_INT,
    repeated: {
      ITEM: true
    }
  },
  custom_shipping_box_id: {
    token: 'SQ_FPSCSBI',
    type: attrType.STRING
  }
};
export const CATALOG_SERVICE_TOKEN_TO_ATTRIBUTE_DEF_MAP = {};
for (const k in CATALOG_SERVICE_ATTRIBUTE_DEFINITIONS) {
  const v = CATALOG_SERVICE_ATTRIBUTE_DEFINITIONS[k];

  // @ts-expect-error no elegant way to fix this
  v.name = k;

  // @ts-expect-error no elegant way to fix this
  CATALOG_SERVICE_TOKEN_TO_ATTRIBUTE_DEF_MAP[v.token] = v;
}

// https://prototype.sqprod.co/#/docs/squareup.items.merchant.CatalogObjectType
export const CATALOG_SERVICE_TYPES = {
  ITEM: 1,
  GIFT_CARD: 1,
  // GIFT_CARD has cogsType="ITEM" and itemType="GIFT_CARD"
  APPOINTMENTS_SERVICE: 1,
  // same as gift cards
  ITEM_IMAGE: 2,
  PAGE_TILE: 3,
  CATEGORY: 4,
  // or Category
  ITEM_VARIATION: 5,
  // or Product
  FEE: 6,
  PLACEHOLDER: 7,
  DISCOUNT: 8,
  COMP_DISCOUNT: 8,
  // COMP_DISCOUNT has cogsType="DISCOUNT" and applicationMethod="COMP"
  ITEM_FEE_MEMBERSHIP: 9,
  ITEM_MODIFIER_LIST: 10,
  ITEM_ITEM_MODIFIER_LIST_MEMBERSHIP: 11,
  ITEM_MODIFIER_OPTION: 12,
  PROMO: 15,
  INVENTORY_INFO: 16,
  DINING_OPTION: 18,
  TAX_RULE: 19,
  PAGE: 21,
  TICKET_GROUP: 22,
  TICKET_TEMPLATE: 23,
  VOID_REASON: 24,
  ITEM_VARIATION_VENDOR_INFO: 25,
  MENU: 26,
  TAG: 27,
  FLOOR_PLAN: 28,
  FLOOR_PLAN_TILE: 29,
  MENU_GROUP_MEMBERSHIP: 31,
  SURCHARGE: 32,
  PRICING_RULE: 33,
  PRODUCT_SET: 34,
  TIME_PERIOD: 35,
  SURCHARGE_FEE_MEMBERSHIP: 36,
  SUBSCRIPTION_PLAN: 38,
  ITEM_OPTION: 39,
  COMPONENT: 47,
  COMPOSITION: 48,
  RESOURCE: 49,
  SUBSCRIPTION_PHASE: 50,
  OBJECT_IMAGE_MEMBERSHIP: 51,
  CHECKOUT_LINK: 52,
  CHECKOUT_LINK_LINE_ITEM: 53,
  CATALOG_CONFIGURATION: 58,
  CREDIT_REDEMPTION_POLICY: 62,
  AGE_RESTRICTION: 63,
  COMBO_SLOT: 64,
  SALE_PRICE: 65,
  RECIPE: 66,
  INGREDIENT: 67
};

// These types are modeled as subclasses of other types.
// COMP_DISCOUNT -> DISCOUNT
// GIFT_CARD, APPOINTMENTS_SERVICE -> ITEM
export const CATALOG_SUBCLASS_TYPES = ['COMP_DISCOUNT', 'GIFT_CARD', 'APPOINTMENTS_SERVICE'];
export const CATALOG_SERVICE_QUERY_TYPES = {
  PREFIX: 1,
  EXACT: 2,
  RANGE: 3,
  TOKEN: 4,
  TEXT: 5,
  LEGACY_ID: 6,
  NEIGHBOR: 7,
  SORTED_ATTRIBUTE: 8,
  SET: 9,
  ATTRIBUTE_VALUES: 10
};
export const CATALOG_SERVICE_TYPES_INVERSE = {};
for (const k in CATALOG_SERVICE_TYPES) {
  // COMP_DISCOUNT and GIFT_CARD are subclasses of DISCOUNT and ITEM, respectively,
  // and they have the same type numbers, so they should not be put in this map.
  const v = CATALOG_SERVICE_TYPES[k];
  if (!CATALOG_SUBCLASS_TYPES.includes(k)) {
    CATALOG_SERVICE_TYPES_INVERSE[v] = k;
  }
}
export const UNIT_OVERRIDE_SUPPORT = {
  ITEM: ['enabled'],
  GIFT_CARD: ['enabled'],
  APPOINTMENTS_SERVICE: ['enabled'],
  ITEM_IMAGE: ['enabled'],
  PAGE_TILE: ['enabled'],
  CATEGORY: ['straightFire'],
  ITEM_VARIATION: ['price', 'pricingType', 'enabled', 'trackInventory'],
  COMPONENT: ['enabled'],
  COMPOSITION: ['enabled'],
  FEE: ['enabled'],
  PLACEHOLDER: ['enabled'],
  DISCOUNT: ['enabled'],
  COMP_DISCOUNT: [],
  ITEM_FEE_MEMBERSHIP: ['enabled'],
  ITEM_MODIFIER_LIST: ['enabled'],
  ITEM_ITEM_MODIFIER_LIST_MEMBERSHIP: ['enabled'],
  ITEM_MODIFIER_OPTION: ['enabled', 'price'],
  PROMO: ['enabled'],
  INVENTORY_INFO: ['enabled'],
  DINING_OPTION: ['enabled'],
  TAG: ['enabled'],
  TAX_RULE: ['enabled'],
  TICKET_GROUP: ['enabled'],
  TICKET_TEMPLATE: ['enabled'],
  PAGE: ['enabled'],
  MENU: ['enabled'],
  FLOOR_PLAN: ['enabled'],
  FLOOR_PLAN_TILE: ['enabled'],
  MENU_GROUP_MEMBERSHIP: ['enabled'],
  SURCHARGE: ['enabled'],
  SURCHARGE_FEE_MEMBERSHIP: ['enabled'],
  PRICING_RULE: ['enabled'],
  PRODUCT_SET: ['enabled'],
  TIME_PERIOD: ['enabled'],
  RESOURCE: ['enabled'],
  SUBSCRIPTION_PLAN: ['enabled'],
  SUBSCRIPTION_PHASE: ['enabled'],
  COMBO_SLOT: ['enabled'],
  RECIPE: ['enabled'],
  INGREDIENT: ['enabled']
};
export const UNIT_OVERRIDE_ONLY_ATTRIBUTES = ['inventory_alert_threshold', 'inventory_alert_type', 'inventory_availability_rule', 'inventory_availability_rule_expires_at', 'inventory_in_stock_count', 'sold_out', 'sold_out_valid_until', 'fractional_inventory_in_stock_count', 'fractional_inventory_committed_count', 'fractional_inventory_available_count'];

// Server has implemented a unique constraint on default attribute for
// ItemVariationVendorInfo (and possibly others coming soon). Therefore, you can
// have only 'TRUE' or NULL values.
export const TRUE_ONLY_ATTRIBUTES = ['is_default'];

// these are Dashboard-only overrides used while an item/variations is being edited.
// we have to keep track of stock count changes in progress that might get canceled.
export const TEMP_FRACTIONAL_INVENTORY_IN_STOCK_COUNT = 'temp_fractional_inventory_in_stock_count';
export const TEMP_FRACTIONAL_INVENTORY_AVAILABLE_COUNT = 'temp_fractional_inventory_available_count';
export const ASYNC_SERVICE_STATUS_CODES = {
  DO_NOT_USE: 0,
  // An import is actively in progress
  IN_PROGRESS: 1,
  // The import was successful (and there is no import in progress)
  SUCCESS: 2,
  // The import failed (and there is no import in progress)
  ERROR: 3,
  // A cancel has been requested by the user, but the import is still in progress.
  CANCEL_REQUESTED: 4,
  // The import was canceled by the user (and there is no import in progress)
  CANCELLED: 5,
  // The last import status showed an import in progress, but it is so old that it has been marked as
  // timed out. You can assume there is no import in progress.
  TIMED_OUT: 6
};
export const CATALOG_ITEM_OPTION_VALUE_NAME_MAX_LENGTH = 65;
export const CATALOG_ITEM_OPTION_NAME_MAX_LENGTH = 255;
export const CATALOG_STRING_ATTRIBUTE_MAX_LENGTH = 255;
export const CATALOG_TEXT_ATTRIBUTE_MAX_LENGTH = 4096;
export const SEARCH_CATALOG_STOCK_LEVEL = {
  OUT: 1,
  LOW: 2
};
export const SEARCH_CATALOG_SELLABLE_TYPE = {
  SELLABLE: 1,
  NON_SELLABLE: 2
};

// These attributes are added to objects as they pass through items-bulk.
// They will cause an unknown attribute error if sent to items directly.
export const ITEMS_BULK_FAKE_ATTRIBUTES = ['fractional_inventory_in_stock_count', 'fractional_inventory_committed_count', 'fractional_inventory_available_count', 'inventory_availability_rule', 'inventory_availability_rule_expires_at', 'inventory_in_stock_count', 'inventory_stock_received_count', 'inventory_adjustment_unit_cost', 'inventory_adjustment_currency_code'];

// Limit units to 250
export const MAX_MEASUREMENT_UNITS = 250;
export const CATALOG_OBJECT_AVAILABILITY_STATE = {
  AVAILABLE: 'AVAILABLE',
  SOLD_OUT: 'SOLD_OUT'
};

// This should be updated as new catalog models are added
// TODO: how do we verify that this is up to date?
export const CATALOG_MODEL_NAMES = [
// items-v3-base
'item', 'category', 'combo-slot', 'component', 'composition', 'dining-option', 'discount', 'fee', 'ingredient', 'item-fee-membership', 'item-item-modifier-list-membership', 'item-modifier-list', 'item-modifier-option', 'item-variation', 'item-variation-vendor-info', 'object-image-membership', 'pricing-rule', 'product-set', 'promo', 'recipe', 'resource', 'sale-price', 'subscription-phase', 'subscription-plan', 'surcharge', 'surcharge-fee-membership', 'tax-rule', 'time-period', 'void-reason', 'floor-plan', 'floor-plan-tile', 'menu', 'menu-group-membership', 'page', 'page-tile', 'placeholder', 'tag', 'ticket-group', 'ticket-template',
// catalog-object
'connect/address', 'connect/checkout-link', 'connect/coordinates', 'connect/custom-attribute-definition', 'connect/event', 'connect/image', 'connect/item', 'connect/item-variation', 'connect/item-option', 'connect/item-option-value', 'connect/measurement-unit', 'connect/subscription-plan'];

// TODO: move this to measurement unit when moving model to items-data addon
export const MEASUREMENT_UNIT_MAX_PRECISION = 5;
export const SERVICE_COST_PERCENTAGE_PRECISION = 5;